import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";

import AuditDataTable from "./AuditDataTable";

const AuditPage = (props) => (
  <div className="full-height audit">
    {!!props.children ? (
      props.children
    ) : (
      <div className="full-height">
        <div className="page-header">
          <div className="main clearfix">
            <div className="main-name">
              <h2>
                <FormattedMessage id="audit.title" />
              </h2>
            </div>
          </div>
        </div>
        <div className="sub-container">
          <div className="sub-content">
            <AuditDataTable />
          </div>
        </div>
      </div>
    )}
  </div>
);

AuditPage.propTypes = {
  children: PropTypes.node,
};

export default AuditPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/audit/AuditPage.js